var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90078 0.5C4.86978 0.5 0.800781 4.569 0.800781 9.6C0.800781 16.425 9.90078 26.5 9.90078 26.5C9.90078 26.5 19.0008 16.425 19.0008 9.6C19.0008 4.569 14.9318 0.5 9.90078 0.5ZM3.40078 9.6C3.40078 6.012 6.31278 3.1 9.90078 3.1C13.4888 3.1 16.4008 6.012 16.4008 9.6C16.4008 13.344 12.6568 18.947 9.90078 22.444C7.19678 18.973 3.40078 13.305 3.40078 9.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90039 12.8497C11.6953 12.8497 13.1504 11.3947 13.1504 9.59973C13.1504 7.80481 11.6953 6.34973 9.90039 6.34973C8.10547 6.34973 6.65039 7.80481 6.65039 9.59973C6.65039 11.3947 8.10547 12.8497 9.90039 12.8497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLocation);
export default __webpack_public_path__ + "static/media/white-location.a229b86ae046d20e538aec527f54d589.svg";
export { ForwardRef as ReactComponent };